export default __webpack_public_path__ + "static/media/ra.61893925.jpg";